<template>
  <div>
    <div class="works-filter">
      <div class="works-filter__block works-filter__block-list disable">
        <filter-search-sub/>
      </div>

      <div class="works-filter__block works-filter__block-list disable">
        <filter-annotation-sub v-if="filters_counts.annotation=='y'"/>
        <filter-audioguides-sub v-if="filters_counts.audioguides=='y'"/>
        <filter-insale-sub/>
        <filter-video-sub v-if="filters_counts.video=='y'"/>
        <filter-interior-sub v-if="filters_counts.interior=='y'"/>
      </div>

      <filter-arttype-sub label_class="works-filter__labels"/>
      <filter-genre-sub label_class="works-filter__labels"/>
      <filter-style-sub label_class="works-filter__labels"/>
      <filter-technique-sub label_class="works-filter__labels"/>
      <filter-period-sub label_class="works-filter__labels"/>
      <filter-color-sub :is_show="false" @updated="childupdated"/>
      <filter-price-sub/>
      <filter-size-sub label_class="works-filter__labels"/>
      <filter-pl-region-sub/>
      <filter-region-sub :is_show="false" @updated="childupdated"/>
      <filter-author-sub v-if="to_gallery_id>0" :is_show="false" @updated="childupdated"/>
      <filter-place-sub :is_show="false" @updated="childupdated" label_class="works-filter__labels" :max_visible="100500"/>
    </div>
    <div class="works-filter__block works-filter__block-advanced-filter">
      <a class="works-filter__block-title works-filter__block-hide pointer" v-on:click="toggleFilters">
        <span class="item-text">{{ advanced? $t("message.AdvancedFilter") : $t("message.ToggleFilter") }}</span>
      </a>
    </div>
  </div>
</template>


<script>
  import FilterAnnotationSub from "./filter/FilterAnnotationSub";
  import FilterAudioguidesSub from "./filter/FilterAudioguidesSub";
  import FilterInteriorSub from "./filter/FilterInteriorSub";
  import FilterInsaleSub from "./filter/FilterInsaleSub";

  import FilterArttypeSub from "./filter/FilterArttypeSub";
  import FilterGenre from "../../../../components/list/filter/FilterGenre";
  import FilterStyle from "../../../../components/list/filter/FilterStyle";
  import FilterTechnique from "../../../../components/list/filter/FilterTechnique";
  import FilterPriceSub from "./filter/FilterPriceSub";
  import FilterRegionSub from "./filter/FilterRegionSub";

  import WorksFilterMix from "../../../../components/list/WorksFilterMix";
  import FilterGenreSub from "./filter/FilterGenreSub";
  import FilterStyleSub from "./filter/FilterStyleSub";
  import FilterTechniqueSub from "./filter/FilterTechniqueSub";
  import FilterPeriodSub from "./filter/FilterPeriodSub";
  import FilterColorSub from "./filter/FilterColorSub";
  import FilterSizeSub from "./filter/FilterSizeSub";
  import FilterPlaceSub from "./filter/FilterPlaceSub";
  import FilterSearchSub from "./filter/FilterSearchSub";
  import FilterAuthorSub from "./filter/FilterAuthorSub";
  import FilterVideoSub from "./filter/FilterVideoSub";
  import FilterPlRegionSub from "./filter/FilterPlRegionSub";

  export default {
    components: {
      FilterPlRegionSub,
      FilterVideoSub,
      FilterPlaceSub,
      FilterSizeSub,
      FilterColorSub,
      FilterPeriodSub,
      FilterArttypeSub,
      FilterAnnotationSub,
      FilterAudioguidesSub,
      FilterInteriorSub,
      FilterInsaleSub,

      FilterTechniqueSub,
      FilterStyleSub,
      FilterGenreSub,
      FilterGenre, FilterStyle, FilterTechnique,
      FilterPriceSub,
      FilterRegionSub, FilterSearchSub, FilterAuthorSub
    },
    name      : 'works-filter-sub',
    data() {
      return {
        to_gallery_id: $('#app-wrapper').attr('gallery_id'),
      }
    },
    mixins: [WorksFilterMix],

    created   : function () {
      this.$store.dispatch ('addUsedFilters', 'FiltersCounts');
    },
    destroyed : function () {
      this.$store.dispatch ('removeUsedFilters', 'FiltersCounts');
    },
  }
</script>



// WEBPACK FOOTER //
// src/sub/flat_light/components/list/WorksFilterSub.vue